import API from './API';
var verifyUser = function (data, config) {
    return API.post('/auth/verify_user', data, config);
};
;
var login = function (data, config) {
    return API.post('/auth/login', data, config);
};
var verify2FA = function (data, config) {
    return API.post('/auth/confirm_2fa', data, config);
};
var TFASecret = function (config) {
    return API.get('/auth/tfa_secret', config);
};
var logout = function (data, config) {
    return API.post('/auth/logout', data, config);
};
var users = function (config) {
    return API.get('/auth/users', config);
};
var requestPasswordReset = function (data, config) {
    return API.post('/auth/request_password_reset', data, config);
};
var resetPassword = function (data, config) {
    return API.post('/auth/reset_password', data, config);
};
export default {
    verifyUser: verifyUser,
    login: login,
    verify2FA: verify2FA,
    TFASecret: TFASecret,
    logout: logout,
    users: users,
    requestPasswordReset: requestPasswordReset,
    resetPassword: resetPassword
};
